/* AvailableDockletsComponent.js */

"use strict";
const EventEmitter = require("events").EventEmitter;
const Renderer = require("./AvailableDockletsRenderer");

class AvailableDockletsComponent extends EventEmitter {
    constructor(config) {
        super();
        this._state = config.state;
        this._renderer = new Renderer(this);
        this._registerListeners();
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS */

    /*******************************************/
    _registerListeners() {
        this._state.on("stateChanged", (this._onStateChanged = this._onStateChanged.bind(this)));
    }

    _unregisterListeners() {
        this._state.removeListener("stateChanged", this._onStateChanged);
    }

    _onStateChanged() {
        if (!this._state.disabled) {
            this.renderer.render();
        }
    }

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS */
    /* START PUBLIC COMPONENT MODEL METHODS */

    /*******************************************/
    get renderer() {
        return this.getRenderer();
    }

    getRenderer() {
        return this._renderer;
    }

    shutdown() {
        let prom = new Promise((resolve) => {
            this._unregisterListeners();
            this._state = null;
            this._renderer = null;
            resolve();
        });
        this.emit("Shutdown");
        return prom;
    }

    getAvailableParts() {
        return this._state.availableParts;
    }

    getAvailablePart(name) {
        return this._state.getAvailablePart(name);
    }

    getActivePart(id) {
        return this._state.getActivePart(id);
    }

    pinIconClicked() {
        this.emit("pinIconClicked");
    }

    activateDocklet(type) {
        this.emit("activateDocklet", type);
    }

    /*******************************************/
    /* END COMPONENT MODEL METHODS */
    /* START PRIVATE METHODS */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE METHODS */
    /* START PUBLIC API METHODS */
    /*******************************************/

    /*******************************************/
    /* END PUBLIC API METHODS */
    /*******************************************/
}

module.exports = AvailableDockletsComponent;
